import { Injectable } from '@angular/core';

import { BehaviorSubject } from 'rxjs';

export interface DebugLog {
  id: string;
  type: 'otp' | 'error' | 'request' | 'response' | 'info';
  timestamp: string;
  title: string;
  details?: any;
  status?: number;
}

export interface OtaBundleInfo {
  targetNativeVersion: string;
  compatibleNativeVersions?: string[];
  latestBuildNumber: number;
  bundleVersion: string;
  bundleUrl?: string;
  checksum?: string;
  isMandatory?: boolean;
}

export interface ServerInfo {
  nodeEnv: string;
  smsProvider: string;
  version: string;
  minClientVersion?: string;
  latestClientVersion?: string;
  isMaintenance?: boolean;
  maintenanceMessage?: string;
  storeUrls?: {
    android?: string;
    ios?: string;
  };
  ota?: OtaBundleInfo;
  buildNumber?: number;
  commitSha?: string;
  branch?: string;
  buildTimestamp?: string;
  timestamp?: string;
}

@Injectable({
  providedIn: 'root',
})
export class HelperDebugLoggerControllerService {
  private logsSubject = new BehaviorSubject<DebugLog[]>([]);
  public logs$ = this.logsSubject.asObservable();

  private latestOtpSubject = new BehaviorSubject<string | null>(null);
  public latestOtp$ = this.latestOtpSubject.asObservable();

  private serverInfoSubject = new BehaviorSubject<ServerInfo | null>(null);
  public serverInfo$ = this.serverInfoSubject.asObservable();

  addLog(type: DebugLog['type'], title: string, details?: any, status?: number): void {
    const newLog: DebugLog = {
      id: Math.random().toString(36).substring(2, 9),
      type,
      timestamp: new Date().toLocaleTimeString(),
      title,
      details,
      status,
    };

    if (details && typeof details === 'object') {
      const target = details.data || details;
      const possibleOtp =
        target.otp ||
        target.debugOtp ||
        target.otpCode ||
        target.code ||
        target.pin ||
        details.otp ||
        details.debugOtp ||
        details.code;

      if (possibleOtp) {
        this.latestOtpSubject.next(String(possibleOtp));
      } else if (typeof target === 'object' && target !== null) {
        for (const key of Object.keys(target)) {
          const val = String(target[key] || '');
          if (/^\d{4,6}$/.test(val) && !key.toLowerCase().includes('uuid') && !key.toLowerCase().includes('id') && !key.toLowerCase().includes('status')) {
            this.latestOtpSubject.next(val);
            break;
          }
        }
      }
    }

    const current = this.logsSubject.getValue();
    this.logsSubject.next([newLog, ...current.slice(0, 49)]);
  }

  setLatestOtp(otp: string): void {
    this.latestOtpSubject.next(otp);
  }

  setServerInfo(info: ServerInfo): void {
    this.serverInfoSubject.next(info);
  }

  clearLogs(): void {
    this.logsSubject.next([]);
  }
}
